import { createContext, MutableRefObject } from 'react';
import LookControls from '../common/three/look-controls';

type TContext = {
  controls?: MutableRefObject<LookControls | undefined>;
};

const initialValue: TContext = {
  controls: undefined,
};

export const context = createContext<TContext>(initialValue);
